<template>
  <div class="cases-skeleton">
    <div class="skeleton-category" v-for="i in 3" :key="i">
      <div class="skeleton-title"></div>
      <div class="skeleton-cases">
        <div class="skeleton-case" v-for="j in 6" :key="j">
          <div class="skeleton-case-inner"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'CasesSkeletonLoader' })
</script>

<style scoped lang="scss">
.cases-skeleton {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-top: 1rem;
  padding-bottom: 4rem;

  .skeleton-category {
    .skeleton-title {
      height: 36px;
      width: 200px;
      background: linear-gradient(90deg, rgba($elevation1, 0.6) 25%, rgba($elevation2, 0.4) 50%, rgba($elevation1, 0.6) 75%);
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite;
      border-radius: 4px;
      margin-bottom: 1em;

      @include mobile {
        margin: 0 auto 1em;
      }
    }

    .skeleton-cases {
      display: flex;
      flex-wrap: wrap;
      gap: 1.1em;

      @include tablet {
        justify-content: center;
      }

      @include mobile {
        gap: 0.85em;
      }

      .skeleton-case {
        width: 235px;
        height: 300px;

        @include mobile {
          width: 175px;
          height: 260px;
        }

        .skeleton-case-inner {
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, rgba($elevation1, 0.6) 25%, rgba($elevation2, 0.4) 50%, rgba($elevation1, 0.6) 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 12px;
        }
      }
    }
  }

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
}
</style>